// extracted by mini-css-extract-plugin
export default {"container":"footer-module--container--e4696","copyright":"footer-module--copyright--68e6e","container_internal":"footer-module--container_internal--7aab1"};